// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing013({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/013/241118_01.gif`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/013/241118_02.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/013/241118_03.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/013/241118_04.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/013/241118_05.jpg`}
      img6Path={`${process.env.REACT_APP_CDN_BASE}/images/013/241118_06.jpg`}
      qOptionColor="blue"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/013/241118_07.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
    />
  );
}

export default Randing013;
